import { Link } from 'react-router-dom';
import { LandingNavbar } from '@/features/landing/components/landing-navbar';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, Library } from 'lucide-react';
import { resourceSections } from '../data/resources-data';

export function ResourcesPage() {
  return (
    <div className="min-h-screen bg-white">
      <LandingNavbar />

      {/* Spacer for fixed navbar */}
      <div className="h-16" />

      {/* Hero */}
      <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 mb-6">
            <Library className="w-7 h-7 text-primary" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Centro de Recursos</h1>
          <p className="mt-3 text-lg text-muted-foreground max-w-2xl mx-auto">
            Documentación, guias, casos de éxito y documentos legales de Prixia.
          </p>
        </div>
      </section>

      {/* Resource sections */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        {resourceSections.map((section) => (
          <div key={section.title} className="mt-12">
            <h2 className="text-xl font-semibold mb-6">{section.title}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {section.items.map((item) => (
                <Card key={item.title} className="group hover:shadow-md transition-shadow">
                  <CardContent className="p-5">
                    <div className="flex items-start gap-4">
                      <div className="shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                        <item.icon className="w-5 h-5 text-primary" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h3 className="font-medium text-sm leading-tight">{item.title}</h3>
                        <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                          {item.description}
                        </p>
                        <Link
                          to={item.href}
                          className="inline-flex items-center mt-2 text-xs text-primary hover:underline font-medium"
                        >
                          Ver <ArrowRight className="w-3 h-3 ml-1" />
                        </Link>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        ))}
      </main>

      {/* Footer */}
      <footer className="border-t border-border bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Prixia. Todos los derechos reservados.
            </p>
            <nav className="flex items-center gap-6">
              <Link
                to="/terms"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Terminos
              </Link>
              <Link
                to="/privacy"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Privacidad
              </Link>
              <Link
                to="/contract"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Contrato SaaS
              </Link>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
}
